import React from 'react';
import { Box, Dialog, Divider, Grid, Stack, Typography } from '@mui/material';
import styles from 'custom/style.module.css';
import manifestStyles from './manifest.module.css';
import { CustomButton, CustomDialogTitle, CustomDialogAction, CustomDialogContent } from 'custom/components';
// import { CloseIconBtn } from 'custom/constants';
import cookies from 'utils/cookies';

const FfmModal = (props) => {
  const verifyFfm = () => {
    let stn = cookies.get('station_code');

    if (props.ffm?.dest === stn) {
      if (props.ffm?.in_ffm && props.ffm.in_ffm.processing === false && props.ffm.in_ffm.verify === 1) {
        return true;
      }
    } else {
      console.log('out ffm', props.ffm?.out_ffm);
      if (props.ffm?.out_ffm && props.ffm.out_ffm.processing === false && props.ffm.out_ffm.verify === 1) {
        return true;
      }
    }

    return false; // Ensure a boolean is always returned
  };
  const getawbCount = (ulds) => {
    let awbs = [];
    ulds?.forEach(uld => {
      uld?.flight_awbs?.forEach(awb => {
        if (!awbs.includes(awb.awb_no)) {
          awbs.push(awb.awb_no);
        }
      });
    });
    return awbs.length;
  };

  return (
    <div>
      <Dialog
        aria-labelledby='form-dialog-title'
        open={verifyFfm()} // Call the function and use its return value
        onClose={props.onClose}
      >
        <CustomDialogTitle id='form-dialog-title'>
          Manifest Details
          {/* <CloseIconBtn onClick={props.onClose} /> */}
        </CustomDialogTitle>
        <CustomDialogContent sx={{ width: 600 }}>
          <Divider textAlign='left'>
            <Typography variant='body2' fontWeight={600}>Verify the below manifest details</Typography>
          </Divider>
          <Box className={manifestStyles.detailsBox}>
            <Grid container spacing={3}>
              <Grid item xs>
                <Stack direction='row-reverse' alignItems='baseline' justifyContent='center' spacing={1} borderRight='2px solid var(--secondarygreen)' className={manifestStyles.detailsStack}>
                  <Typography variant='caption' textTransform='uppercase' fontWeight={700} color='text.disabled'>Ulds</Typography>
                  <Typography variant='h4' color='primary'>{props.ffm?.flight_uld?.filter(uld => !uld.is_bulk).length || 0}</Typography>
                </Stack>
              </Grid>
              <Grid item xs>
                <Stack direction='row-reverse' alignItems='baseline' justifyContent='center' spacing={1} borderRight='2px solid var(--secondarygreen)' className={manifestStyles.detailsStack}>
                  <Typography variant='caption' textTransform='uppercase' fontWeight={700} color='text.disabled'>Awbs</Typography>
                  <Typography variant='h4' color='primary'>
                    {/* {props.ffm?.flight_uld?.reduce(
                    (acc, curr) => acc + (curr.flight_awbs ? curr.flight_awbs.length : 0),
                    0
                  ) || 0} */}
                    {getawbCount(props.ffm?.flight_uld || []) || 0}
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs='auto' minWidth={'33.33%'}>
                <Stack direction='row-reverse' alignItems='baseline' justifyContent='center' spacing={1} className={manifestStyles.detailsStack}>
                  <Typography variant='caption' textTransform='uppercase' fontWeight={700} color='text.disabled'>kgs wt</Typography>
                  <Typography variant='h4' color='primary'>{props.ffm?.flight_uld?.reduce(
                    (acc, curr) =>
                      acc +
                      (curr.flight_awbs
                        ? curr.flight_awbs.reduce((a, c) => a + parseFloat(c.wgt || 0), 0)
                        : 0),
                    0
                  )?.toFixed(2) || 0}{' '}
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </CustomDialogContent>
        <CustomDialogAction className={`${styles.fSpaceBtw}`}>
          <CustomButton variant='contained' onClick={props.acceptFfm}>
            Accept
          </CustomButton>
          <CustomButton
            variant='contained'
            onClick={() => {
              document.getElementById('ffm-file').click();
            }}
          >
            Re-Upload
          </CustomButton>
        </CustomDialogAction>
      </Dialog>
    </div>
  );
};

export default FfmModal;